import { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useListProducts } from 'api/products';
import { client } from 'api/api-client';
import { useOrder } from 'api/orders';
// import { useCupon } from 'api/cupons';
import { WithFormError } from 'components/ui/Form/Form';
import { VALIDATION_MESSAGES } from 'constants/validation';
import { checkTaxNumber } from 'utils/utils';
import { Order } from '../../../types/order';

const useOrderPage = () => {
  const [orderData, setOrderData] = useState({
    products: [],
    cupon: '',
    company: '',
    tax: '',
    zip: '',
    city: '',
    street: '',
    streetType: '',
    house: '',
    staircase: '',
    floor: '',
    door: '',
    name: '',
    email: '',
    tel: ''
  } as Order);

  const { data, isLoading } = useListProducts();
  const validationSchema = Yup.object().shape({
    products: Yup.array().test({
      test: (value, context) =>
        data.filter(
          (product) =>
            (document.getElementsByName(`product_${product.id}`)[0] as HTMLInputElement)
              ?.checked
        ).length > 0,
      message: VALIDATION_MESSAGES.no_products
    }),
    name: Yup.string().required(VALIDATION_MESSAGES.required),
    email: Yup.string()
      .required(VALIDATION_MESSAGES.required)
      .email(VALIDATION_MESSAGES.invalid_email),
    tel: Yup.string()
      .required(VALIDATION_MESSAGES.required)
      .matches(
        /^(\+\d{2,3}|06)? ?[-(/ ]?(\d{1,2}[-)/ ]? ?)(\d{3}|\d{2}[- ]?\d{2})[- ]?(\d{3}|\d{2}[- ]?\d{2})$/,
        VALIDATION_MESSAGES.invalid_phone
      ),
    tax: Yup.string()
      .required(VALIDATION_MESSAGES.required)
      .matches(
        /^\d{8}-[1-5]-([0][2-9]|[2][02-9]|[13]\d|4[0-4]|51)$/,
        VALIDATION_MESSAGES.invalid_tax_number
      )
      .test({
        test: (value, context) => checkTaxNumber(value ?? ''),
        message: VALIDATION_MESSAGES.invalid_tax_number
      }),
    company: Yup.string().required(VALIDATION_MESSAGES.required),
    zip: Yup.string().required(VALIDATION_MESSAGES.required),
    city: Yup.string().required(VALIDATION_MESSAGES.required),
    street: Yup.string().required(VALIDATION_MESSAGES.required)
  });
  const formMethods = useForm<WithFormError<Order>>({
    resolver: yupResolver(validationSchema),
    defaultValues: {}
  });

  const { mutateAsync: doOrder, isLoading: isSubmitLoading } = useOrder();
  const handleSubmit = async (order: Order) => {
    const most = new Date();
    doOrder({
      ...order,
      order: `megrendelo_${most.getTime()}`
    }).then((resp) => {
      if (!isSubmitLoading && resp?.startsWith('http')) window.location.href = resp;
    });
  };

  interface IAddress {
    tax: string;
    name: string;
    zip: string;
    city: string;
    street: string;
    streetType: string;
    house: string;
    staircase: string;
    floor: string;
    door: string;
  }

  const getByTax = async (tax: string) => {
    if (!/^\d{8}-[1-5]-([0][2-9]|[2][02-9]|[13]\d|4[0-4]|51)$/.test(tax)) return null;
    return client<IAddress>(`/megr/address/${tax}`, {
      method: 'get'
    });
  };

  const ADDRESS: IAddress = {
    tax: '',
    name: '',
    zip: '',
    city: '',
    street: '',
    streetType: '',
    house: '',
    staircase: '',
    floor: '',
    door: ''
  };

  return {
    orderData,
    setOrderData,
    formMethods,
    listProducts: data,
    isLoading,
    handleSubmit,
    isSubmitLoading,
    getByTax,
    ADDRESS
  };
};

export default useOrderPage;
